module.exports = __webpack_public_path__ + "img/symbol_1.7b75c90b.png";